<template lang="pug">
#betslip-parlay-mmo.modal.modal-bottom.fade.modal-betslip(tabindex='-1' role='dialog' aria-labelledby='betslip-parlay-mmo' aria-hidden='true')
  .modal-dialog.modal-dialog-scrollable.m-0(role='document')
    .modal-content
      .modal-body.p-0
        template(v-if="!isDataExists")
          .bet-slip
            .bet-slip-wrapper
              .stake-info-wrapper
                .close(@click="hideMe()")
                  i.fal.fa-times
                span {{ $t("ui.no_bet") }}
                .stake-info
                  .betslip-match.text-left(v-if="!loading.check") {{ $t("message.bet_empty") }}
                  .betslip-match(v-else)
                    i.fad.fa-spinner.fa-spin
        template(v-else)
          .bet-slip.bet-slip-parlay
            .parlay-slip-header
              .title {{ $t("ui.parlay_slip") }}
              .remove-all(@click="handleCloseAll()") {{ $t("ui.remove_all") }}
            template(v-for="(item, index) in betparlaymmo")
              .bet-slip-wrapper
                .stake-info-wrapper
                  .close(@click="handleCloseBet(item.matchId)")
                    i.fal.fa-times
                  .bet-league
                    img.icon(:src="'/images/icon-sport-svg/' + getSportsImage(item.sportsType)")
                    span [{{ index+1 }}] {{ sports[item.sportsType] }} - {{ $t("m.BS_" + item.betType) }}
                  .stake-info
                    .betslip-match
                      .team-involved
                        .score(v-if="item.marketType == 3 && item.score != ''") {{ item.score }}
                        span(:class="item.giving == 1 && isBallDisplay(item) ? 'team2' : 'team1'") {{ item.homeName }}
                        span.vs(v-if="item.betType != 'OR'") - VS -
                        span(:class="item.giving == 0 && isBallDisplay(item) ? 'team2' : 'team1'" v-if="item.betType != 'OR'") {{ item.awayName }}
                    .selector-odd.d-flex.justify-content-between
                      span.text(:class="isBallDisplay(item) == false ? '' : ((item.giving == 0 && item.homeAway == 2) ? 'team2' : (item.giving == 1 && item.homeAway == 1) ? 'team2' : 'team1')") {{ item.betType }} | {{ item.betDisplay }}
                      .bet-type-odds
                        template(v-if="item.fact.ball_display < 0")
                          span.negetive {{ item.fact.ball_display }}
                        template(v-else)
                          span {{ item.fact.ball_display }}
                        template(v-if="item.fact.criteria2 < 0")
                          span.mr-1.negetive ({{ item.fact.criteria2 }})
                        template(v-else)
                          span.mr-1 ({{ item.fact.criteria2 }})
                        .odds
                          span {{ $t("m.BT_" + item.beton) }}
              .odds-change-notice(v-if="oddsIsUpdating || invalidOdds")
                i.fal.fa-exclamation-circle.text-warning.mr-1
                span {{ $t("error.oddsIsUpdating") }}
              .odds-change-notice(v-if="errorMessage")
                i.fal.fa-exclamation-circle.text-danger.mr-1
                span {{ errorMessage }}
            .footer-slip.text-left
              .d-flex.parlay-group-wrapper
                .btn-add-selection(@click="hideMe()") {{ $t("ui.add_more_selection") }}
              .payout-wrapper.pb-0
                .left {{ $t("ui.odds") }}: {{ $numeral(multi).format("0,0.00[0]") }}
              .payout-wrapper.pt-0
                .left {{ $t("ui.min") }}: {{ $numeral(minBet).format("0,0") }} | {{ $t("ui.max") }}: {{ $numeral(maxBet).format("0,0") }}
                .right {{ $t("ui.payout") }}: {{ $numeral(payout).format("0,0.00[0]") }}
              template(v-if="betparlayCount >= 2")
                .stake-wrapper
                  .d-flex.justify-content-between.flex-fill.mr-1.bet-input
                    .d-flex.align-items-center.flex-fill.mr-1.stake-input-wrapper
                      .text-secondary.stake-decrement.pl-2.pr-2(@click="decreaseStake")
                        i.fas.fa-minus-circle
                      .stake-mask.flex-fill(@click="maskStake")
                        StakeInput(v-model="stake" @handleStake="handleStake" ref="stake" :loadbet="loading.check")
                      .text-secondary.stake-increment.pl-2.pr-2(@click="increaseStake")
                        i.fas.fa-plus-circle
                      .text-secondary.stake-cancel.pl-2.pr-2(@click="clearStake")
                        i.fas.fa-times-circle
                  #place-bet.place-bet
                    SpinButton(css="btn-warning btn-sm rounded-0 text-center text-uppercase" @click="bet()" :text="$t('ui.process_bet')" :loading="loading.process")
                .keyboard
                  .pt-2.pl-2.pr-2.pb-1.cluster
                    .row.mx-0
                      .col-2.px-0.text-center.button-tap(@click="keyStake('1')")
                        span 1
                      .col-2.px-0.text-center.button-tap(@click="keyStake('2')")
                        span 2
                      .col-2.px-0.text-center.button-tap(@click="keyStake('3')")
                        span 3
                      .col-2.px-0.text-center.button-tap(@click="keyStake('4')")
                        span 4
                      .col-2.px-0.text-center.button-tap(@click="keyStake('5')")
                        span 5
                      .col-2.px-0.text-center.button-tap.special.pt-2.del(@click="deleteStake()")
                        span DEL
                        br
                        i.fas.fa-long-arrow-alt-left
                    .row.mx-0
                      .col-2.px-0.text-center.button-tap(@click="keyStake('6')")
                        span 6
                      .col-2.px-0.text-center.button-tap(@click="keyStake('7')")
                        span 7
                      .col-2.px-0.text-center.button-tap(@click="keyStake('8')")
                        span 8
                      .col-2.px-0.text-center.button-tap(@click="keyStake('9')")
                        span 9
                      .col-2.px-0.text-center.button-tap(@click="keyStake('0')")
                        span 0
                      .col-2.px-0.text-center.button-tap.special.pt-3.text-dark.done(@click="doneStake()")
                        span DONE
                  .pt-0.pl-2.pr-2.pb-0
                    .row.mx-0
                      .col-3.px-0.text-center.add-stake(@click="fastStake(20)")
                        span + 20
                      .col-3.px-0.text-center.add-stake(@click="fastStake(50)")
                        span + 50
                      .col-3.px-0.text-center.add-stake(@click="fastStake(100)")
                        span + 100
                      .col-3.px-0.text-center.add-stake.btn-max(@click="maxStake")
                        span {{ $t("ui.max") }}
                .bet-infosub
                  .checkbox
                    label.d-flex(@click="handleAcceptAnyOdds")
                      input(type="checkbox" :checked="betting.acceptAnyOdds == 'true'")
                      span.label(@click="handleAcceptAnyOdds") {{ $t("ui.accept_any_odds") }}
                  .checkbox
                    label.d-flex(@click="handleRememberStake")
                      input(type="checkbox" :checked="betting.defaultStake == '0'")
                      span.label(@click="handleRememberStake") {{ $t("ui.remember_stake") }}
</template>

<script>
import { EventBus } from "@/library/_event-bus.js";
import xhrBet from "@/library/_xhr-betmmo.js";
import calc from "@/library/_calculation.js";
import config from "@/config";
import StakeInput from "@/components/mobile/bets/new/stakeInput";
import SpinButton from "@/components/ui/SpinButton";
import mixinBetType from "@/library/mixinBetType";
import mixinDelay from "@/library/mixinDelay";
import naming from "@/library/_name";

export default {
  components: {
    SpinButton,
    StakeInput
  },
  mixins: [mixinBetType, mixinDelay],
  data() {
    return {
      errorMessage: "",
      debounceBet: null,
      loading: {
        check: false,
        cancel: false,
        process: false
      },
      league: {},
      match: {},
      child: {},
      defaultCounter: 10,
      counter: 10,
      placeSlip: {},
      stake: null,
      payout: null,
      invalidOdds: false,
      oddsIsUpdating: false,
      autoCloseOddsIsUpdating: null,
      parlayMatch: {},
      betConfirm: false,
      isMMO: false
    };
  },
  computed: {
    mmoMode() {
      return this.$store.getters.mmoMode;
    },
    sports() {
      return this.$store.state.layout.sports;
    },
    commType() {
      return this.$store.getters.commType;
    },
    multi() {
      var result = 1;
      for (var n in this.betparlaymmo) {
        // result = result * parseFloat(this.betparlaymmo[n].val);
        result = result * 2;
      }
      var f = parseFloat(calc.fm(result, false, 4)).toFixed(3);
      return f;
    },
    maxBet() {
      // var max = calc.truncateInteger(this.maxParlayPayout / this.multi);
      // for (var n in this.betparlaymmo) {
      //   if (max > parseFloat(this.betparlaymmo[n].maxBet)) {
      //     max = parseFloat(this.betparlaymmo[n].maxBet);
      //   }
      // }
      var c = Object.keys(this.betparlaymmo).length;
      var d = 0.85;
      if (c > 3) {
        d = 0.8;
      }

      var max = calc.truncateInteger(this.maxParlayPayout / this.multi / d);
      for (var n in this.betparlaymmo) {
        if (max > parseFloat(this.betparlaymmo[n].maxBet)) {
          max = parseFloat(this.betparlaymmo[n].maxBet);
        }
      }
      return max;
    },
    minBet() {
      var result = 0;
      for (var n in this.betparlaymmo) {
        if (result == 0) {
          result = this.betparlaymmo[n].minBet;
        } else {
          if (result < this.betparlaymmo[n].minBet) {
            result = this.betparlaymmo[n].minBet;
          }
        }
      }
      return result;
    },
    maxPayout() {
      var result = 0;
      for (var n in this.betparlaymmo) {
        if (result == 0) {
          result = this.betparlaymmo[n].maxPayout;
        } else {
          if (result < this.betparlaymmo[n].maxPayout) {
            result = this.betparlaymmo[n].maxPayout;
          }
        }
      }
      return result;
    },
    maxParlayPayout() {
      var result = 0;
      for (var n in this.betparlaymmo) {
        if (result == 0) {
          result = this.betparlaymmo[n].maxParlayPayout;
        } else {
          if (result > this.betparlaymmo[n].maxParlayPayout) {
            result = this.betparlaymmo[n].maxParlayPayout;
          }
        }
      }
      return result;
    },
    menu4() {
      return this.$store.getters.menu4;
    },
    betparlaymmo() {
      var tempOrder = [];
      tempOrder = Object.values(this.$store.state.betparlaymmo.data).sort(function(a, b) {
        return a.bettime < b.bettime ? -1 : a.bettime > b.bettime ? 1 : 0;
      });
      return tempOrder;
    },
    betparlayCount() {
      return Object.keys(this.$store.state.betparlaymmo.data).length;
    },
    pageDisplay() {
      return this.$store.getters.pageDisplay;
    },
    betting() {
      return this.$store.getters.betting;
    },
    currencyCode() {
      return this.$store.getters.currencyCode.replace('UST', 'USDT');
    },
    isDataExists() {
      if (Object.keys(this.betparlaymmo).length > 0) {
        return true;
      } else {
        return false;
      }
    },
    isPlaceBet() {
      // if (Object.keys(this.betparlaymmo).length >= 2) {
      if (Object.keys(this.betparlaymmo).length >= config.mmoParlayMinTicket) {
        return true;
      } else {
        return false;
      }
    }
  },
  watch: {
    stake(newVal) {
      this.handlePayout();
    },
    multi(newVal) {
      this.handlePayout();
    }
  },
  destroyed() {
    clearInterval(this.autoRefresh);
  },
  mounted() {
    this.debounceBet = this.debounce(this.processBet, 1000);
    setInterval(this.autoRefresh, this.defaultCounter * 1000);
    EventBus.betParlayMMO = this.runbet;
    EventBus.closeParlayMMO = this.handleCloseBet;
    EventBus.showParlayMMO = this.showMe;
    EventBus.cancelParlayMMO = this.handleCloseAll;
  },
  methods: {
    bet() {
      this.loading.process = true;
      this.errorMessage = "";
      this.betConfirm = true;
      if (this.debounceBet) {
        this.debounceBet();
      }
    },
    showMe() {
      this.loading.process = false;
      $("#betslip-parlay-mmo").modal("show");
    },
    hideMe() {
      $("#betslip-parlay-mmo").modal("hide");
    },
    handleRememberStake() {
      this.$store.dispatch("layout/setSingleBetting", { property: "defaultStake", value: this.betting.defaultStake == "0" ? "3" : "0" });
    },
    isBallDisplay(e) {
      // var result = naming.ballDisplay2(e.ballOrigin, e.giving, e.homeAway, e.betType, this);
      var result = naming.ballDisplay2(e.fact.ball_display, e.giving, e.homeAway, e.betType, this);
      if (["HDP", "HDPH"].includes(e.betType)) {
        return result != null && result != "0";
      } else {
        return false;
      }
    },
    getBallDisplay(b, g, ha, bt) {
      return naming.ballDisplay2(b, g, ha, bt, this);
    },
    existsInSlip(odds) {
      return Object.keys(this.$store.state.betparlaymmo.data).includes(odds[1].toString());
    },
    runbet(odds, typ, idx, val, bt, amt, isMMO, e, pos, giving) {
      if (!isMMO && !this.mmoMode) {
        this.$helpers.showDialog(this.$t("ui.action"), this.$t("error.invalidCurrency"), "error");
        return;
      }

      if (!this.existsInSlip(odds)) {
        if (Object.keys(this.$store.state.betparlaymmo.data).length + 1 > config.parlayMaxTicket) {
          this.$helpers.showDialog(this.$t("ui.action"), this.$t("error.maxParlayTicket"), "info");
          return;
        }
      }
      if (EventBus.cancelParlay) EventBus.cancelParlay();

      this.isMMO = isMMO;
      this.stake = amt;
      this.handleStake();
      this.checkParlayBet(odds, typ, idx, val, bt, e, pos, giving);
      if (this.$refs.stake) {
        this.$refs.stake.focus();
      }
      clearTimeout(this.autoCloseOddsIsUpdating);
      this.invalidOdds = false;
      this.oddsIsUpdating = false;
    },
    cache() {
      return this.$store.getters.data;
    },
    fastBet() {
      if (this.isPlaceBet) {
        document.onkeyup = null;
        this.handleStake();
        this.$swal({ title: this.$t("ui.confirmation"), text: this.$t("message.confirmation"), type: "info", showCancelButton: true }).then(result => {
          if (result.value) {
            this.bet();
          }
        });
      }
    },
    processConfirmBet() {
      this.errorMessage = "";
      this.betConfirm = true;
      document.onkeyup = event => {
        if (event.which == 13 || event.keyCode == 13) {
          this.bet();
        } else {
          if (event.which == 27 || event.keyCode == 27) {
            this.betConfirm = false;
          }
        }
      };
    },
    handleCloseBet(e) {
      this.$store.dispatch("betparlaymmo/removeData", e);
      this.parlayMatch[e] = 0;
    },
    handleCloseAll() {
      this.$store.dispatch("betparlaymmo/clearData");
      this.parlayMatch = {};
      this.hideMe();
    },
    processBet() {
      if (!this.betConfirm || Object.keys(this.betparlaymmo).length == 0) return;

      this.errorMessage = "";
      this.betConfirm = false;
      this.loading.process = true;
      var old = this.placeSlip;
      var validBet = true;
      this.placeSlip = {
        account_id: this.$store.getters.accountId,
        session_token: this.$store.getters.sessionToken,
        bet_member: this.stake,
        accept_any_odds: this.betting.acceptAnyOdds,
        bet_detail: [],
        operator_type: this.$store.getters.operatorType,
        parent_id: this.$store.getters.parentId
      };

      if (this.stake > this.maxBet) {
        this.$helpers.showDialog(this.$t("ui.action"), this.$t("error.betOverMaxBet"), "info");
        this.loading.process = false;
        this.betConfirm = true;
        return;
      }

      for (var n in this.betparlaymmo) {
        var item = {};
        item["a"] = this.betparlaymmo[n].oddsId;
        item["b"] = this.betparlaymmo[n].subMatchId;
        item["c"] = this.betparlaymmo[n].matchId;
        item["d"] = this.betparlaymmo[n].betType;
        item["e"] = this.betparlaymmo[n].betTeamId;
        item["f"] = this.betparlaymmo[n].homeAway;
        item["g"] = parseFloat(this.betparlaymmo[n].val);
        item["h"] = parseFloat(this.betparlaymmo[n].origin);
        item["j"] = this.betparlaymmo[n].ballDisplay;
        item["k"] = this.betparlaymmo[n].fact.criteria2;
        this.placeSlip.bet_detail.push(item);
        if (this.betparlaymmo[n].betStatus == "false") {
          validBet = false;
        }
      }

      if (!validBet) {
        this.$helpers.showDialog(this.$t("ui.action"), this.$t("error.matchHide"), "info");
        this.loading.process = false;
        this.betConfirm = true;
        return;
      }

      old = null;
      var cloneSlip = Object.assign({}, this.betparlaymmo);
      var sumSlip = {};
      sumSlip.stake = this.stake.toString();
      sumSlip.payout = this.payout.toString();
      sumSlip.multi = this.multi.toString();
      xhrBet.betParlay(this.placeSlip).then(
        res => {
          // this.loading.process = false;
          if (res.success) {
            if (this.$store.state.layout.betting.defaultStake == "0") {
              this.$store.dispatch("layout/setSingleBetting", { property: "defaultStakeAmount", value: this.stake });
            }

            this.hideMe();

            if (EventBus.betParlayStatusMMO) {
              EventBus.betParlayStatusMMO(cloneSlip, sumSlip, res);
            }

            if (EventBus.getBalance) {
              EventBus.getBalance();
            }
          } else {
            this.$helpers.handleFeedback(res.status);
          }
        },
        err => {
          this.loading.process = false;
          switch (err.status) {
            case "insufficient_balance":
              this.errorMessage = this.$t("error.insufficient_balance");
              break;
            case "atLeastThreeMatchToBetParlay":
              break;
            case "betLowerMin":
              this.errorMessage = this.$t("error.betLowerMin");
              break;
            case "betOverLimit":
              this.errorMessage = this.$t("error.betOverMaxBet");
              break;
            case "invalidOdds":
              this.invalidOdds = true;
              this.refreshOddsYes();
              break;
            case "oddsIsUpdating":
              this.oddsIsUpdating = true;
              clearTimeout(this.autoCloseOddsIsUpdating);
              this.autoCloseOddsIsUpdating = setTimeout(() => {
                this.oddsIsUpdating = false;
              }, this.defaultCounter * 1000);
              break;
            default:
              this.$helpers.handleFeedback(err.status);
              break;
          }
        }
      );
    },
    handlePayout() {
      // var a = this.stake * this.multi;
      // var b = this.maxBet * this.multi;
      // if (a > b) {
      //   a = b;
      // }
      // this.payout = a.toFixed(3);
      var c = Object.keys(this.betparlaymmo).length;
      var d = 0.85;
      if (c > 3) {
        d = 0.8;
      }
      var a = this.stake * this.multi * d;
      var b = this.maxBet * this.multi;
      if (a > b) {
        a = b;
      }
      this.payout = a.toFixed(3);
    },
    handleStake() {
      if(this.stake % 1 != 0) {
        this.stake = Math.round(this.stake);
      }
      if (this.stake == null || this.stake == undefined || this.stake == "") {
      } else {
        if (parseInt(this.stake) > this.maxBet) {
          this.stake = this.maxBet;
        } else {
          if (parseInt(this.stake) < this.minBet) {
            this.stake = this.minBet;
          }
        }
      }
    },
    clearStake() {
      this.stake = "";
      $(".stake-cancel").hide();
      $(".stake-decrement").show();
      $(".stake-increment").show();
    },
    increaseStake() {
      if (this.stake == null || this.stake == undefined || this.stake == "") {
        this.stake = this.minBet;
      }
      if (parseInt(this.stake) < this.maxBet) {
        if(parseInt(this.stake) * 2 > this.maxBet) {
          this.stake = this.maxBet;
        } else {
          this.stake = parseInt(this.stake) * 2;
        }
      }
    },
    decreaseStake() {
      if (this.stake == null || this.stake == undefined || this.stake == "") {
        this.stake = this.minBet;
      }
      if (parseInt(this.stake) > this.minBet) {
        if(parseInt(this.stake) / 2 < this.minBet) {
          this.stake = this.minBet;
        } else {
          this.stake = parseInt(this.stake) / 2;
        }
      }
    },
    fastStake(amount) {
      if (this.stake == null || this.stake == undefined || this.stake == "") {
        this.stake = amount;
      } else {
        if (parseInt(this.stake) < this.maxBet) {
          if(parseInt(this.stake) + amount > this.maxBet) {
            this.stake = this.maxBet;
          } else {
            this.stake = parseInt(this.stake) + amount;
          }
        }
      }
    },
    maxStake() {
      this.stake = this.maxBet;
    },
    maskStake() {
      $(".keyboard").slideDown();
      $(".stake-decrement").hide();
      $(".stake-increment").hide();
      $(".stake-cancel").show();
    },
    keyStake(e) {
      // this.$helpers.playTouchSound(e)
      this.stake = this.stake.toString() + e.toString();
    },
    deleteStake() {
      var c = this.stake.toString();
      if (c.length > 0) {
        this.stake = c.slice(0, -1);
        this.handleStake();
      }
    },
    doneStake() {
      $(".keyboard").slideUp();
      $(".stake-cancel").hide();
      $(".stake-decrement").show();
      $(".stake-increment").show();
      $("#place-bet").show();
    },
    checkMatchExists() {
      var result = true;
      if (this.betparlaymmo != null) {
        var cache = this.cache();
        var otflag1 = false;
        var otflag2 = false;

        if (cache != null && cache.hasOwnProperty("match")) {
          for (var n in this.betparlaymmo) {
            if (!cache.match.hasOwnProperty(this.betparlaymmo[n].matchId)) {
              this.$store.dispatch("betparlaymmo/setSingleData", { matchid: this.betparlaymmo[n].matchId, property: "betStatus", value: "false" });
            } else {
              // check odds exist if match have more than 1 ot
              if (cache.match.hasOwnProperty(this.betparlaymmo[n].matchId)) {
                if (cache.odds[1] != undefined) {
                  if (cache.odds[1]["hdp"] != undefined) {
                    if (cache.odds[1]["hdp"][this.betparlaymmo[n].matchId]) {
                      for (var m in cache.odds[1]["hdp"][this.betparlaymmo[n].matchId]) {
                        if (cache.odds[1]["hdp"][this.betparlaymmo[n].matchId][m][3] == this.betparlaymmo[n].oddsId) {
                          otflag1 = true;
                        }
                      }
                      this.$store.dispatch("betparlaymmo/setSingleData", { matchid: this.betparlaymmo[n].matchId, property: "betStatus", value: otflag1 });
                      if (otflag1) return result;
                    }
                  }

                  if (cache.odds[1]["ou"] != undefined) {
                    if (cache.odds[1]["ou"][this.betparlaymmo[n].matchId]) {
                      for (var m in cache.odds[1]["ou"][this.betparlaymmo[n].matchId]) {
                        if (cache.odds[1]["ou"][this.betparlaymmo[n].matchId][m][3] == this.betparlaymmo[n].oddsId) {
                          otflag1 = true;
                        }
                      }
                      this.$store.dispatch("betparlaymmo/setSingleData", { matchid: this.betparlaymmo[n].matchId, property: "betStatus", value: otflag1 });
                      if (otflag1) return result;
                    }
                  }

                  if (cache.odds[1]["oe"] != undefined) {
                    if (cache.odds[1]["oe"][this.betparlaymmo[n].matchId]) {
                      for (var m in cache.odds[1]["oe"][this.betparlaymmo[n].matchId]) {
                        if (cache.odds[1]["oe"][this.betparlaymmo[n].matchId][m][3] == this.betparlaymmo[n].oddsId) {
                          otflag1 = true;
                        }
                      }
                      this.$store.dispatch("betparlaymmo/setSingleData", { matchid: this.betparlaymmo[n].matchId, property: "betStatus", value: otflag1 });
                      if (otflag1) return result;
                    }
                  }

                  if (cache.odds[1]["oxt"] != undefined) {
                    if (cache.odds[1]["oxt"][this.betparlaymmo[n].matchId]) {
                      for (var m in cache.odds[1]["oxt"][this.betparlaymmo[n].matchId]) {
                        if (cache.odds[1]["oxt"][this.betparlaymmo[n].matchId][m][3] == this.betparlaymmo[n].oddsId) {
                          otflag1 = true;
                        }
                      }
                      this.$store.dispatch("betparlaymmo/setSingleData", { matchid: this.betparlaymmo[n].matchId, property: "betStatus", value: otflag1 });
                      if (otflag1) return result;
                    }
                  }

                  if (cache.odds[1]["ml"] != undefined) {
                    if (cache.odds[1]["ml"][this.betparlaymmo[n].matchId]) {
                      for (var m in cache.odds[1]["ml"][this.betparlaymmo[n].matchId]) {
                        if (cache.odds[1]["ml"][this.betparlaymmo[n].matchId][m][3] == this.betparlaymmo[n].oddsId) {
                          otflag1 = true;
                        }
                      }
                      this.$store.dispatch("betparlaymmo/setSingleData", { matchid: this.betparlaymmo[n].matchId, property: "betStatus", value: otflag1 });
                      if (otflag1) return result;
                    }
                  }

                  if (cache.odds[1]["orz"] != undefined) {
                    if (cache.odds[1]["orz"][this.betparlaymmo[n].matchId]) {
                      for (var m in cache.odds[1]["orz"][this.betparlaymmo[n].matchId]) {
                        if (cache.odds[1]["orz"][this.betparlaymmo[n].matchId][m][3] == this.betparlaymmo[n].oddsId) {
                          otflag1 = true;
                        }
                      }
                      this.$store.dispatch("betparlaymmo/setSingleData", { matchid: this.betparlaymmo[n].matchId, property: "betStatus", value: otflag1 });
                      if (otflag1) return result;
                    }
                  }
                }

                if (cache.odds[2] != undefined) {
                  if (cache.odds[2]["hdp"] != undefined) {
                    if (cache.odds[2]["hdp"][this.betparlaymmo[n].matchId]) {
                      for (var m in cache.odds[2]["hdp"][this.betparlaymmo[n].matchId]) {
                        if (cache.odds[2]["hdp"][this.betparlaymmo[n].matchId][m][3] == this.betparlaymmo[n].oddsId) {
                          otflag2 = true;
                        }
                      }
                      this.$store.dispatch("betparlaymmo/setSingleData", { matchid: this.betparlaymmo[n].matchId, property: "betStatus", value: otflag1 });
                      if (otflag1) return result;
                    }
                  }

                  if (cache.odds[2]["ou"] != undefined) {
                    if (cache.odds[2]["ou"][this.betparlaymmo[n].matchId]) {
                      for (var m in cache.odds[2]["ou"][this.betparlaymmo[n].matchId]) {
                        if (cache.odds[2]["ou"][this.betparlaymmo[n].matchId][m][3] == this.betparlaymmo[n].oddsId) {
                          otflag2 = true;
                        }
                      }
                      this.$store.dispatch("betparlaymmo/setSingleData", { matchid: this.betparlaymmo[n].matchId, property: "betStatus", value: otflag1 });
                      if (otflag1) return result;
                    }
                  }

                  if (cache.odds[2]["oe"] != undefined) {
                    if (cache.odds[2]["oe"][this.betparlaymmo[n].matchId]) {
                      for (var m in cache.odds[2]["oe"][this.betparlaymmo[n].matchId]) {
                        if (cache.odds[2]["oe"][this.betparlaymmo[n].matchId][m][3] == this.betparlaymmo[n].oddsId) {
                          otflag2 = true;
                        }
                      }
                      this.$store.dispatch("betparlaymmo/setSingleData", { matchid: this.betparlaymmo[n].matchId, property: "betStatus", value: otflag1 });
                      if (otflag1) return result;
                    }
                  }

                  if (cache.odds[2]["oxt"] != undefined) {
                    if (cache.odds[2]["oxt"][this.betparlaymmo[n].matchId]) {
                      for (var m in cache.odds[2]["oxt"][this.betparlaymmo[n].matchId]) {
                        if (cache.odds[2]["oxt"][this.betparlaymmo[n].matchId][m][3] == this.betparlaymmo[n].oddsId) {
                          otflag2 = true;
                        }
                      }
                      this.$store.dispatch("betparlaymmo/setSingleData", { matchid: this.betparlaymmo[n].matchId, property: "betStatus", value: otflag1 });
                      if (otflag1) return result;
                    }
                  }

                  if (cache.odds[2]["ml"] != undefined) {
                    if (cache.odds[2]["ml"][this.betparlaymmo[n].matchId]) {
                      for (var m in cache.odds[2]["ml"][this.betparlaymmo[n].matchId]) {
                        if (cache.odds[2]["ml"][this.betparlaymmo[n].matchId][m][3] == this.betparlaymmo[n].oddsId) {
                          otflag2 = true;
                        }
                      }
                      this.$store.dispatch("betparlaymmo/setSingleData", { matchid: this.betparlaymmo[n].matchId, property: "betStatus", value: otflag1 });
                      if (otflag1) return result;
                    }
                  }

                  if (cache.odds[2]["orz"] != undefined) {
                    if (cache.odds[2]["orz"][this.betparlaymmo[n].matchId]) {
                      for (var m in cache.odds[2]["orz"][this.betparlaymmo[n].matchId]) {
                        if (cache.odds[2]["orz"][this.betparlaymmo[n].matchId][m][3] == this.betparlaymmo[n].oddsId) {
                          otflag2 = true;
                        }
                      }
                      this.$store.dispatch("betparlaymmo/setSingleData", { matchid: this.betparlaymmo[n].matchId, property: "betStatus", value: otflag1 });
                      if (otflag1) return result;
                    }
                  }
                }
              }
            }
          }
        } else {
          result = false;
        }
      }
      return result;
    },
    autoRefresh() {
      this.errorMessage = "";
      if (this.isDataExists) {
        if ((this.betting.autoRefreshOdds == true || this.betting.autoRefreshOdds == "true") && this.isDataExists) {
          for (var n in this.betparlaymmo) {
            this.requestSingleBet(this.betparlaymmo[n], true);
          }
        }
      }
    },
    handleAutoRefresh() {
      this.$store.dispatch("layout/setSingleBetting", { property: "autoRefreshOdds", value: this.betting.autoRefreshOdds == "true" ? "false" : "true" });
      this.counter = this.defaultCounter;
    },
    handleAcceptAnyOdds() {
      this.$store.dispatch("layout/setSingleBetting", { property: "acceptAnyOdds", value: this.betting.acceptAnyOdds == "true" ? "false" : "true" });
    },
    refreshOddsYes() {
      this.invalidOdds = false;
      this.counter = this.defaultCounter;
      for (var n in this.betparlaymmo) {
        this.requestSingleBet(this.betparlaymmo[n]);
      }
    },
    refreshOddsNo() {
      this.invalidOdds = false;
    },
    getBetLimit() {
      return this.$store.getters.playerBetLimit["PARLAY"];
    },
    cancelBetClick() {
      this.cancelBet();
    },
    cancelBet() {
      clearTimeout(this.autoCloseOddsIsUpdating);
      this.invalidOdds = false;
      this.oddsIsUpdating = false;
      this.loading.cancel = true;
      this.loading.check = false;
      this.league = {};
      this.match = {};
      this.counter = this.defaultCounter;
      this.$store.dispatch("betparlaymmo/clearData").then(() => {
        this.loading.cancel = false;
        this.loading.process = false;
      });
    },
    checkParlayBet(odds, typ, idx, val, bt, e, pos, homeaway) {
      this.counter = this.defaultCounter;
      this.loading.check = true;
      var cache = this.cache();
      if (cache.hasOwnProperty("league") && cache.hasOwnProperty("match")) {
        var sd = {};

        sd.matchId = odds[1];
        sd.child = cache.child[sd.matchId];
        sd.parent = cache.parent[sd.matchId];

        if (sd.child != undefined) {
          for (var n in sd.child) {
            this.$store.dispatch("betparlaymmo/removeData", sd.child[n][0]);
          }
        }

        if (sd.parent != undefined) {
          this.$store.dispatch("betparlaymmo/removeData", sd.parent);
        }

        sd.typ = typ;
        sd.idx = idx;
        sd.val = val;
        sd.pos = pos;
        sd.beton = homeaway == 1 ? odds[4] == "HDP" ? "H" : "O" : odds[4] == "HDP" ? "A" : "U";

        sd.leagueId = odds[0];
        sd.subMatchId = odds[2];
        sd.oddsId = odds[3];
        sd.betType = odds[4];
        sd.ballOrigin = odds[8];
        sd.target = bt;

        this.league = cache.league[sd.leagueId];
        this.match = cache.match[sd.matchId];

        sd.sportsType = this.league[1];
        sd.leagueId = this.league[0];
        sd.leagueName = this.league[4];

        var limit = this.getBetLimit();
        sd.minBet = limit.min_bet;
        sd.maxBet = limit.max_bet;
        sd.maxPayout = limit.max_payout;
        sd.maxParlayPayout = 0;
        sd.marketType = this.match[4];
        sd.homeName = this.match[5];
        sd.awayName = this.match[6];
        sd.workingDate = this.match[7];
        sd.matchTime = this.match[8];
        sd.homeId = this.match[22];
        sd.awayId = this.match[23];
        sd.score = this.match[11] ? this.match[11].toString().trim() : "";
        sd.awayId = this.match[23];
        sd.typId = config.oddsTypeId[sd.typ];
        sd.ballDisplay = "";
        sd.betDisplay = "";

        this.setBetTypeMMO(sd, odds);
        this.requestSingleBet(sd, false);

        this.league = null;
        this.match = null;
      }
    },
    requestSingleBet(data, refresh) {
      if (data == null) {
        this.cancelBet("requestSingleBetNoData");
        return;
      }
      if (!data.betType || !data.oddsId || !data.sportsType) {
        this.cancelBet("requestSingleBetInvalid");
        return;
      }

      var slip = {
        account_id: this.$store.getters.accountId,
        session_token: this.$store.getters.sessionToken,
        sports_type: data.sportsType,
        parlay: data.target == "parlay",
        odds_id: data.oddsId,
        submatch_id: data.subMatchId,
        bet_type: data.betType,
        bet_team_id: data.betTeamId,
        home_away: data.homeAway,
        odds_display: parseFloat(data.val),
        odds_mo: parseFloat(data.origin),
        odds_type: data.typId,
        ball_display: data.ballDisplay,
        criteria2: data.fact.criteria2,
        market_type: data.marketType
      };
      var cache = this.cache();
      xhrBet.betSingleOddsCheck(slip).then(
        res => {
          if (res.success) {
            if (data != null) {
              var sd = Object.assign({}, data);
              sd.oddsChanged = res.data[0].odds_change;
              sd.ldiffChanged = res.data[0].ldiff_change;
              sd.ballChanged = res.data[0].ball_change;
              if (res.data[0].home_giving == true) {
                sd.giving = 1;
              } else {
                sd.giving = 0;
              }
              if (res.data[0].ball_display_new != null) {
                sd.ballChangedText = this.getBallDisplay(sd.ballDisplay, sd.giving, sd.homeAway, sd.betType);
                sd.ballDisplay = res.data[0].ball_display_new;
              }
              if (res.data[0].ldiff_new != null) {
                sd.ldiffChangedText = sd.fact.criteria2;
                sd.criteria2 = res.data[0].ldiff_ori;
                sd.fact = naming.ballDisplayMMO(sd.ballDisplay.toString(), sd.giving, sd.homeAway, sd.betType, sd.criteria2);
                // sd.fact.criteria2 = res.data[0].ldiff_new;
              }
              if (res.data[0].odds_display_new != null) {
                sd.oddsChangedText = sd.val;
                sd.val = calc.fmtType(res.data[0].odds_display_new, this.commType, sd.betType);
              }
              if (res.data[0].odds_new != null) {
                sd.origin = calc.fmt(res.data[0].odds_new);
              }
              if (sd.minBet < res.data[0].min_bet) {
                sd.minBet = res.data[0].min_bet;
              }
              if (sd.maxBet > res.data[0].max_bet) {
                sd.maxBet = res.data[0].max_bet;
              }
              sd.maxParlayPayout = res.data[0].max_parlay_payout;
              var flag = 1;
              if (!refresh) {
                Object.keys(this.parlayMatch).forEach(
                  function(i) {
                    if (i == sd.matchId) {
                      flag = 0;
                      sd.bettime = this.parlayMatch[sd.matchId];
                    }

                    if (i == sd.matchId && this.parlayMatch[sd.matchId] == 0) {
                      flag = 1;
                    }
                  }.bind(this)
                );

                if (flag) {
                  sd.bettime = new Date().getTime();
                  this.parlayMatch[sd.matchId] = sd.bettime;
                }
              }
              sd.betStatus = true;
              sd.multi = 2;
              this.$store.dispatch("betparlaymmo/setData", sd);
              this.loading.check = false;
              this.invalidOdds = false;
            }
          } else {
            this.$helpers.handleFeedback(res.status);
          }
        },
        err => {
          this.$helpers.handleFeedback(err.status);
        }
      );
    }
  }
};
</script>
